import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/shared/session.service';

@Injectable({ providedIn: 'root' })

export class AuthGuard  {

  constructor(
    private router: Router,
    private authServ: AuthService,
    private session: SessionService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.session.isAuthenticated()) {
      this.authServ.isUser.next(true);
      return true;
    }
    else {
      this.authServ.isUser.next(false);
      this.authServ.stateUrl = state.url;
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

}
